import React, { Component } from 'react';
import './studentidcard.css';
import { connect } from "react-redux";
import {
    detailsIDCard,
    downloadStudentCard,
    uploadStudentImage
} from 'Actions';

 // app config
 import AppConfig from 'Constants/AppConfig';

class StudentIdCard extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            // agreements: this.props.studentidcardlist.agreements[0],
            // parent: this.props.studentidcardlist.parent[0],
            // student: this.props.studentidcardlist.student[0],
            frm:this.props.data.frm,
        };
        this.download = this.download.bind(this);
        this.handleUpload = this.handleUpload.bind(this);
    }
    download = async (ctsaID) => {
       
        try {
            await this.props.downloadStudentCard(ctsaID);
            
        } catch (error) {
            console.error('Error occurred while downloading the PDF:', error);
        }
    }



    handleFileChange = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();

        reader.onloadend = () => {
            this.setState({
                selectedFile: file,
                base64Image: reader.result,
            });
        };

        reader.readAsDataURL(file);
    };




    handleUpload(ctsd_studentID) {
        const { base64Image } = this.state;

        this.props.uploadStudentImage(ctsd_studentID, base64Image)
            .then((data) => {
                console.log(data)
            })
            .catch((error) => {
                console.log(error)
            });
    }


    render() {
        const { studentidcardlist } = this.props;
        const student = studentidcardlist.student[0];
        const parent = studentidcardlist.parent[0];
        const agreements = studentidcardlist.agreements[0];
        const agrstart = agreements.ctsa_agreement_start_date;
        const stdate = new Date(agrstart);
        const stgetYear = stdate.getFullYear();
        const startYear = stgetYear.toString().slice(-2);

        const agrend = agreements.ctsa_agreement_end_date;
        const eddate = new Date(agrend);
        const edgetYear = eddate.getFullYear();
        const endYear = edgetYear.toString().slice(-2);
  
        return (
            <div>
                <div className="card">
                    <div className="card-header">
                        <div className="row align-items-center">
                            <div className="col-6">
                                <h3 className="mb-0">ID Card</h3>
                            </div>
                            <div className="col-6">
                               <div className="dd text-right">
                                <button type="button" className="mr-10 mb-10 btn btn-outline-info ml-auto" onClick={(event) => {
                                        event.preventDefault();
                                        this.download(agreements.ctsaID);
                                    }}>
                                        Download
                                    </button>
                                {this.state.frm==1 ?
                                    <button type="button" className="mr-10 mb-10 btn btn-outline-warning ml-auto" onClick={this.props.onClick}>Back</button>
                                : '' }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="row">
                            <div className={this.state.frm==1? "col-sm-12 col-lg-6" :"col-sm-12 col-lg-12"}>
                                <div className="stdcard">
                                    <div className="row">
                                        <div className="col-sm-6 col-lg-8">
                                            <img
                                                src="https://portal.tsgacademy.in/Backend/public/theme/img/brand/idcardLogo.png"
                                                width="70%"
                                                alt="ID Card Logo"
                                            />
                                        </div>
                                        <div className="col-sm-6 col-lg-4 stucrdlab">STUDENT</div>
                                    </div>
                                    <div className="row stdcrdorng">
                                        <div className="stdcrdphto" id="shwprfimage">
                                            <img
                                                className="profileimage"
                                                src={AppConfig.apiurl+'/theme/img/profile_images/'+student.uud_profileimage}
                                                alt="Student Profile"
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="stdcrdyear">
                                            TSG / <span id="idcrdyear">{startYear}-{endYear}</span>
                                        </div>
                                    </div>
                                    <div className="row stdcrdname">
                                        <div class="col-lg-12"><strong>Name :</strong> <span id="idcrdname">{student.uud_firstName} {student.uud_lastName}</span> </div>
                                        <div className="col-lg-12">
                                            <strong>Validity : </strong>
                                            <span id="idcrdvalid">{agreements.eddate}</span>
                                        </div>
                                        <div className="col-lg-12">
                                            <strong>Enrolment ID : <span id="idcrdenrl">{agreements.ctsa_enrollmentID}</span></strong>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={this.state.frm==1? "col-sm-12 col-lg-6" :"col-sm-12 col-lg-12"}>
                                <div className="stdcard">
                                    <div className="row"></div>
                                    <div className="row stdcrdorngbck">
                                        <h2 className="stdcardbckhead">Student details</h2>
                                        <div className="col-lg-12 stdcrdbckinp">
                                            <strong>Parent Name : <span id="idcrdpname">{parent.uud_firstName} {parent.uud_lastName}</span></strong>
                                        </div>
                                        <div className="col-lg-12 stdcrdbckinp">
                                            <strong>Parent Phone No : <span id="idcrdpno">{parent.uud_phone}</span></strong>
                                        </div>
                                        <div className="col-lg-12 stdcrdbckinp">
                                            <strong>Home Address :  <span id="idcrdpadd">
                                                {parent.uud_address}
                                            </span></strong>
                                        </div>
                                        <div className="col-lg-12 stdcrdbckinp">
                                            <strong>Blood Group :   <span id="idcrdblood">{student.ctsd_bloodgroup}</span></strong>
                                        </div>
                                        <div className="col-lg-12 stdcrdbckinp"></div>
                                        <h2 className="stdcardbckhead2">Academy details</h2>
                                        <div className="col-lg-12 stdcardbckacdy" style={{color:"black"}}>
                                            Tarun Sardesai Golf Academy at
                                            Zion Hills Golf County, Kolar-Bangarpet Rd,
                                            Hanchala-Bangarpet Post, Kolar - 563114
                                        </div>
                                        <div className="col-lg-12 stdcrdbckinp">
                                            <strong>Contact Name : <span id="idcrdcname">Ajo Jose</span></strong>
                                        </div>
                                        <div className="col-lg-12 stdcrdbckinp">
                                            <strong> Contact No :   <span id="idcrdcno">6364935733</span></strong>
                                        </div>
                                    </div>
                                    <div className="row stdcrdbckaudv">
                                        <div className="col-lg-6"></div>
                                        <div className="col-lg-6">
                                            <img
                                                src="https://portal.tsgacademy.in/Backend/public/theme/img/vakirai.png"
                                                width="80%"
                                                alt="Vakirai"
                                            />{' '}
                                            <span className="stdcrdbckauth">Authorised Signature</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.state.frm==1 ?
                        <div className="imageupload">
                            <h2>Student Photo Upload :</h2>
                            <form
                                id="frm-add"
                                method="post"
                                action="javascript:void(0)"
                                encType="multipart/form-data"
                                onSubmit="uploadimageform()"
                            >
                                <div className="form-body">
                                    <div
                                        id="successMessage"
                                        className="alert alert-success"
                                        style={{ display: 'none' }}
                                    ></div>
                                    <div
                                        id="errorMessage"
                                        className="alert alert-danger"
                                        style={{ display: 'none' }}
                                    ></div>
                                    <div className="row">
                                        <div className="form-group col-xl-4">
                                            <label className="form-control-label" htmlFor="input-username">
                                                Student Image (Format : jpeg, jpg &amp; png)
                                            </label>
                                            <input
                                                className="form-control"
                                                type="file"
                                                name="studimage"
                                                id="studimage"
                                                accept="image/png, image/jpg, image/jpeg"
                                                required=""
                                                onChange={this.handleFileChange}
                                            />
                                        </div>
                                        <div className="form-group col-xl-6">
                                            <div className="form-group" >
                                                <button type="button" className="btn btn-outline-primary" onClick={() => this.handleUpload(student.ctsd_studentID)}>
                                                    <strong>Upload</strong>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        : ''}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ studentid }) => {
    const { studentidcardlist, loading } = studentid;
    return { studentidcardlist, loading };
};

export default connect(mapStateToProps, {
    detailsIDCard,
    downloadStudentCard,
    uploadStudentImage
})(StudentIdCard);
